import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Footer from "../../components/common/Footer";
import HeroSection from "./HeroSection";
import ProcurementOptions from "../../components/common/ProcurementOptions";
import BrowseBySpecimen from "./BrowseBySpecimen";
import DiseaseAreas from "./DiseaseAreas";
import ClinicalAnnotations from "./ClinicalAnnotations";
import { Beaker } from "lucide-react";
import ContactSection from "../../components/common/ContactSection";

const BiospecimensServices = () => {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpanded = (index) => {
    setExpandedItems((prev) => ({ ...prev, [index]: !prev[index] }));
  };
  const customData = [
    {
      title: "Inventory / Retrospective Collections",
      description:
        "Access curated, pre-characterized biospecimens from our diagnostic-led inventory with clinical annotation and ready for immediate global shipment. Ideal for pilot studies, assay validation, and rapid project initiation.",
    },
    {
      title: "Prospective Collections",
      description:
        "Custom-designed specimen collection following your specific protocol. Define inclusion criteria, collection methods, processing requirements, and data annotations. Perfect for studies requiring fresh samples or specific patient populations.",
    },
    {
      title: "Matched Sets",
      description:
        "Paired specimens from the same donor: tumor/normal tissue, pre/post-treatment samples, or longitudinal series. Matched clinical data enables powerful comparative analyses and biomarker discovery.",
    },
    {
      title: "AI-Ready Data. Powered by Diagnostics.",
      description:
        "Structured, clinically annotated datasets derived from diagnostic workflows across diverse sample types—enabling robust AI/ML model training, validation, and real-world performance across multiple disease areas.",
    },
    {
      title: "Bulk Biospecimens. Defined Cohorts. Reliable Supply.",
      description:
        "Diagnostic-derived bulk plasma, serum, and normal expired platelets from well-characterized disease-state and healthy cohorts—supported by clinical annotation, standardized processing, and consistent supply for research and validation needs.",
    },
  ];

  const customData2 = [
    {
      title: "Ethical Collection",
      description:
        "IRB-approved protocols, informed consent documentation, full regulatory compliance with international guidelines.",
    },
    {
      title: "Quality Assurance",
      description:
        "SOP-driven processing, validated storage conditions, comprehensive chain of custody documentation.",
    },
    {
      title: "Data Security",
      description:
        "De-identified specimens, HIPAA-compliant data handling, secure data transfer protocols.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>ANVIYA Biospecimen Services</title>
      </Helmet>

      <main className="w-full bg-white">
        <HeroSection />
        <ProcurementOptions
          title="Our Specialized Services"
          descriptionTitle=" We deliver diagnostic-driven solutions tailored to your research and development needs."
          options={customData}
          icon={Beaker} // Optional: Changes the icon for all cards
        />
        <BrowseBySpecimen />
        <DiseaseAreas />
        <ClinicalAnnotations />
        <ProcurementOptions
          title="Research You Can Trust"
          descriptionTitle="Every ANVIYA biospecimen meets stringent quality and ethical standards:"
          options={customData2}
          icon={Beaker} // Optional: Changes the icon for all cards
          showButton={true}
        />
        <ContactSection />
        <Footer />
      </main>
    </>
  );
};

export default BiospecimensServices;
